import React from 'react'
import { FiCheckCircle } from '@react-icons/all-files/fi/FiCheckCircle'
import Container from '../foundations/Container'
import Media from '../primitives/Media'
import { MEDIA_POLICY_KEYS } from '../primitives/mediaPolicy'
import styles from './ServiceIntroduction.module.scss'

const ServiceIntroduction = ({
  eyebrow,
  heading,
  headingId = 'speaker-service-introduction',
  body,
  guideHeading,
  guideHeadingId = 'speaker-selection-guide',
  guideSummary,
  guideBody,
  image,
  imageAlt,
  signals = []
}) => (
  <section className={styles.section} aria-labelledby={headingId}>
    <Container>
      <div className={styles.mainGrid}>
        <div className={styles.copy}>
          {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
          <h2 id={headingId}>{heading}</h2>
          <div className={styles.body}>{body}</div>
          {signals.length > 0 && (
            <ul className={styles.signals}>
              {signals.map(signal => (
                <li key={signal}>
                  <FiCheckCircle aria-hidden='true' />
                  <span>{signal}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <Media
          picture={image?.picture}
          src={image?.src || image}
          alt={imageAlt}
          policy={MEDIA_POLICY_KEYS.SECTION_SPLIT}
          ratio='4 / 3'
          className={styles.media}
        />
      </div>

      <aside className={styles.guide} aria-labelledby={guideHeadingId}>
        <div>
          <span>Decision support</span>
          <h3 id={guideHeadingId}>{guideHeading}</h3>
          {guideSummary && <p>{guideSummary}</p>}
        </div>
        <div className={styles.guideBody}>{guideBody}</div>
      </aside>
    </Container>
  </section>
)

export default ServiceIntroduction
